import React from "react";
import StatCard from "./cards/StatCard";
import image from "../assets/images/checkered-bg.png";

const data = [
    {
        highlight: '100%',
        title: 'Pass rate',
        description: 'Every student passed their exams under our guidance this year.',
    },{
        highlight: '350+',
        title: 'Improved Grades',
        description: 'From F to A in just one year of dedicated support.',
    },{
        highlight: '95%',
        title: 'A+  Achievers',
        description: 'Almost all students achieved top grades in their exams.',
    }
]

const StatsSection = () => {

    // backgroundImage: `radial-gradient(circle, rgba(0, 0, 0, 0.7) 10%, rgba(0, 0, 0, 0.9) 100%), url(${image})`,
    const backgroundStyle = {
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    };


    return (
        <div
            style={backgroundStyle}
            className={'min-h-screen flex md:flex-row flex-col justify-between md:items-center bg-black text-white py-32 lg:pl-20 sm:pl-12 pl-6 gap-12 pr-4'}>
            <div className={'md:w-[45%] flex flex-col justify-center'}>
                <h1 className={'mb-4 font-semibold lg:text-6xl md:text-5xl text-4xl'}>Our Success in Numbers</h1>
                <p className={'md:text-md text-sm mb-4 text-text-secondary'}>Join the hundreds of students achieving
                    academic excellence with our guidance</p>
                <button className="bg-yellow py-2 px-4 rounded-md mt-4 font-semibold w-max">
                    Enroll now
                </button>
            </div>

            <div className={'flex flex-wrap justify-start gap-6 items-start md:w-[55%] h-max'}>
                {data.map((item, index) => (
                    <React.Fragment key={index}>
                        <StatCard data={item}/>
                    </React.Fragment>
                ))}
            </div>

        </div>
    )
}

export default StatsSection
